import { Pencil, Trash2, Download, Eye, Shield } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FileExplorerItem } from '@features/file-explorer/types'

interface ActionMenuItemsProps {
  item: FileExplorerItem
  onDelete: (item: FileExplorerItem) => void
  onRename: (item: FileExplorerItem) => void
  onDownload: (item: FileExplorerItem) => void
  onShow: (item: FileExplorerItem) => void
  onManagePermissions: (item: FileExplorerItem) => void
  onActionClick?: () => void
}

export default function ActionMenuItems({
  item,
  onDelete,
  onRename,
  onDownload,
  onShow,
  onManagePermissions,
  onActionClick
}: ActionMenuItemsProps) {
  const { t } = useTranslation()

  const handleAction = (action: () => void) => {
    action()
    onActionClick?.()
  }

  return (
    <>
      <li>
        <a onClick={() => handleAction(() => onShow(item))}>
          <Eye className="w-4 h-4" />
          <span>{t('fileExplorer.actions.show')}</span>
        </a>
      </li>
      <li>
        <a onClick={() => handleAction(() => onRename(item))}>
          <Pencil className="w-4 h-4" />
          <span>{t('fileExplorer.actions.rename')}</span>
        </a>
      </li>
      <li>
        <a onClick={() => handleAction(() => onDownload(item))}>
          <Download className="w-4 h-4" />
          <span>{t('fileExplorer.actions.download')}</span>
        </a>
      </li>
      {item.can_manage_permissions && (
        <li>
          <a onClick={() => handleAction(() => onManagePermissions(item))}>
            <Shield className="w-4 h-4" />
            <span>{t('fileExplorer.actions.managePermissions')}</span>
          </a>
        </li>
      )}
      <li>
        <a
          onClick={() => handleAction(() => onDelete(item))}
          className="text-error hover:bg-error/10"
        >
          <Trash2 className="w-4 h-4" />
          <span>{t('fileExplorer.actions.delete')}</span>
        </a>
      </li>
    </>
  )
}
